<template>
    <!--formatter:off-->
    <!-- FIXME figma를 못찾아서 스쿨 svg복사. 나중에 이미지로 수정하는게 좋을 것 같음 -->
    <div class="response_header" v-if="!isPreview"
         :class="{'student': $isIamschoolStudent, 'parents': $isIamschoolParent,'teacher': $isIamteacher}">
        <template v-if="$isIamschoolStudent">
            <!-- iam학생 헤더 -->
            <div class="article_header">
                <div class="logo"></div>
            </div>
            <div class="app_link">
                <a :href="appDownloadURL">
                    <span class="text">
                        아이엠학생 앱으로 보기
                    </span>
                    <div class="arrow_chevron_right"></div>
                </a>
                <div class="app_icon"></div>
            </div>
        </template>
        <template v-if="$isIamschoolParent">
            <!-- iam학부모 헤더 -->
            <div class="article_header">
                <div class="logo"></div>
            </div>
            <div class="app_link">
                <a :href="appDownloadURL">
                    <span class="text">
                        아이엠학부모 앱으로 보기
                    </span>
                    <div class="arrow_chevron_right"></div>
                </a>
                <div class="app_icon"></div>
            </div>
        </template>
        <template v-if="$isIamteacher">
            <div class="article_header">
                <div class="logo"></div>
            </div>
            <div class="app_link">
                <a :href="appDownloadURL">
                    <span class="text">
                        아이엠티처 앱으로 보기
                    </span>
                    <div class="arrow_chevron_right"></div>
                </a>
                <div class="app_icon"></div>
            </div>
        </template>
    </div>
    <!--formatter:on-->
</template>

<script>

export default {
    name: 'ResponseHeader',

    props: {
        isPreview: {
            type: Boolean,
            required: true,
        },
    },

    computed: {
            appDownloadURL() {
                switch (true) {
                    case this.isPreview: // 미리보기 모드
                        return '#';
                    case this.$isIamteacher: // 아이엠티처
                        return process.env.VUE_APP_IAMTEACHER_APP_DOWNLOAD_URL;
                    case this.$isIamschoolStudent: // 아이엠스쿨 학생
                        return process.env.VUE_APP_IAMSTUDENT_APP_DOWNLOAD_URL;
                    case this.$isIamschoolParent: // 아이엠스쿨 학부모
                        return process.env.VUE_APP_IAMPARENT_APP_DOWNLOAD_URL;
                    default: // 기본
                        return process.env.VUE_APP_IAMSCHOOL_APP_DOWNLOAD_URL;
                }
            },
        },
    };
</script>

<style scoped lang="scss">
.article_header {
    display: flex;
    padding: 17px 0px 18px 24px;
    align-items: center;
    flex-shrink: 0;
    background: #00C1DF;

    a {
        display: flex;
    }
}

.app_link {
    display: flex;
    padding: 15px 18px 15px 24px;
    align-items: center;
    background: #E8FAFC;

    .text {
        color: #00ACC7;
        font-feature-settings: 'clig' off, 'liga' off;

        /* Body1/Bold 16 */
        font-family: "Pretendard Variable", Pretendard, sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%; /* 24px */
    }
}

.student {
    .article_header {
        background: #00C1DF;
    }

    .app_link .text {
        color: #00ACC7;
    }
}

.parents {
    .article_header {
        background: #00C6A8;
    }

    .app_link .text {
        color: #00B1A0;
    }
}

.teacher {
    .article_header {
        background: #3577F8;
    }

    .app_link .text {
        color: #3577F8;
    }
}

</style>
